import BILLING_API from 'api/billing/v1'
import { BillingCards } from 'components/BillingCards'
import GridSpinner from 'components/UI/GridSpinner'
import { Button, Container, Icon, Typography } from 'gu-ui-kit'
import { DoublePanelViewLayout } from 'layouts'
import RefundForm from 'modules/Forms/Account/Refund'
import formStyles from 'modules/Forms/common-form.module.scss'
import React, { useEffect, useState } from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useHistory, useRouteMatch } from 'react-router'
import validator from 'utils/asyncValidator'
import { useCancelToken } from 'utils/hooks/useCancelToken'
import styles from 'modules/Services/Refund/refund.module.scss'
import validationSchema from 'modules/Services/Refund/validationSchema'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { FETCH_NETWORK_ACCOUNT } from 'modules/Services/types'

const Refund = () => {
  const history = useHistory()
  const {
    params: { networkType, accountId },
  } = useRouteMatch()
  const { t } = useTranslation()
  const { cancelableDispatch } = useCancelToken()
  const [maxRefundAmount, setMaxRefundAmount] = useState()
  const pathGen = useGeneratePathI18n()

  const { login, office_url } = useSelector((state) => ({
    login: state['services/network-account'].login,
    office_url: state['services/network-account'].office_url,
  }))

  useEffect(() => {
    cancelableDispatch({
      type: FETCH_NETWORK_ACCOUNT,
      payload: { accountId },
    })
  }, [])

  useEffect(() => {
    BILLING_API.calculateRefund({ accountId, data: { amount: null } })
      .then(({ response, error }) => {
        if (error) {
          throw error
        }

        setMaxRefundAmount(response.data.max_refund_amount)
      })
      .catch(() =>
        history.push(
          pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
            networkType,
            accountId,
          }),
        ),
      )
  }, [])

  return (
    <>
      <Helmet defer={false}>
        <title>{t('common::nav_menu.network_account_refund', { login: login })}</title>
      </Helmet>

      <DoublePanelViewLayout
        side={<BillingCards cards={[{ title: t(`billing::methods.getuniq`), id: 'gu-card' }]} />}
        onClose={(e) => {
          e.preventDefault()
          history.push(
            pathGen(ROUTES.SERVICES_NETWORK, {
              networkType,
            }),
          )
        }}
      >
        <div className={formStyles['formContainer__inner']}>
          {networkType && accountId && (
            <>
              <Typography
                variant={'Subtitle-40'}
                className={'margin-bottom-16'}
                component={'h1'}
              >
                {t('services::forms.refund.title', { login: login })}
              </Typography>

              <Container
                className={styles['notification']}
                display={'flex'}
              >
                <div className={styles['notification__emoji-container']}>
                  <Icon name={'emoji-fingerup'} />
                </div>
                <div>
                  <Typography
                    variant={'Subtitle-30'}
                    noMargin
                    className={styles['notification__header']}
                    component={'div'}
                  >
                    {t('services::forms.refund.notification.header')}
                  </Typography>
                  <Typography
                    variant={'Body-15'}
                    className={styles['notification__text']}
                    component={'div'}
                  >
                    {t('services::forms.refund.notification.text')}
                  </Typography>
                  {office_url && (
                    <Button
                      target={'_blank'}
                      variant={'primary'}
                      component={'a'}
                      href={office_url}
                    >
                      {t('services::forms.refund.notification.button_label')}
                    </Button>
                  )}
                </div>
              </Container>
              {maxRefundAmount ? (
                <RefundForm
                  touchOnChange
                  accountId={accountId}
                  networkType={networkType}
                  onClose={() =>
                    history.push(
                      pathGen(ROUTES.SERVICES_NETWORK_ACCOUNT, {
                        networkType,
                        accountId,
                      }),
                    )
                  }
                  asyncValidate={validator(
                    validationSchema({
                      max_amount: maxRefundAmount,
                    }),
                  )}
                />
              ) : (
                <GridSpinner />
              )}
            </>
          )}
        </div>
      </DoublePanelViewLayout>
    </>
  )
}

export default Refund
